import { render, staticRenderFns } from "./menuoption.vue?vue&type=template&id=138f665d"
import script from "./menuoption.vue?vue&type=script&lang=js"
export * from "./menuoption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports